import axios from 'axios';
import { toast } from 'react-toastify';
import CustomToast from '../Component/CustomToast/CustomToast';

export const handleChangeStarCheckBox = ({
  id,
  token,
  setLoading,
  handleGetListForm
}) => {

    
  setLoading(true);

  axios.post(`https://formmaker-api.altynlogistics.com/api/form/${id}/bookmark`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  }).then(response => {
    const bookmarked = response.data.output.bookmark;

    toast(<CustomToast
      message={bookmarked ? 'فرم مورد نظر به لیست علاقمندی‌ها اضافه شد' : 'فرم مورد نظر از لیست علاقمندی‌ها حذف شد'}
      state="success"
    />);

    handleGetListForm();
  }).catch(error => {
    console.error('Error bookmarking form:', error);
  }).finally(() => {
    setLoading(false);
  });
};
